// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Login_errorText__1ewoL","pendingMessage":"Login_pendingMessage__2i3FU","container":"Login_container__7TefY","loginFormWrapper":"Login_loginFormWrapper__1g5S4"};